export const DAY_MODE = 'DAY_MODE';
export const NIGHT_MODE = 'NIGHT_MODE';
export const STEALTH_MODE = 'STEALTH_MODE';
export const UNKNOWN_MODE = 'UNKNOWN_MODE';
